import { useEffect, useState, useCallback } from "react";

const KEY = "mw_household_mode";

// Simple event bus so all components stay in sync when toggle changes
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

export function useHouseholdMode() {
  const [enabled, setEnabled] = useState(() => localStorage.getItem(KEY) === "1");

  useEffect(() => {
    const cb = () => setEnabled(localStorage.getItem(KEY) === "1");
    listeners.add(cb);
    return () => { listeners.delete(cb); };
  }, []);

  const toggle = useCallback((val) => {
    const next = typeof val === "boolean" ? val : !(localStorage.getItem(KEY) === "1");
    if (next) localStorage.setItem(KEY, "1"); else localStorage.removeItem(KEY);
    notify();
  }, []);

  return { enabled, toggle, param: enabled ? { household: true } : {} };
}
